import type { IDailyQuestEventConfig } from '@dev-fast/types';

import { getStaticBaseUrl } from '@app/shared/utils/static-url';

/*
  Note: Урл картинок выглядит чаще всего примерно так домен/название-ивента/год/папка-под-ангуляр/папка-под-медиа-для-ивента
  DOMAIN/EVENT_NAME/HOME_DIR_NAME/FILES_DIR_NAME
 */

const DOMAIN = getStaticBaseUrl();
/** Корень ивента */
const EVENT_NAME = '/rift-chronicles2/';
/** Вложенность раз */
const HOME_DIR_NAME = '';
/** Вложенность два*/
const FILES_DIR_NAME = '';

/** Настройки для ивента с ежедневными заданиями daily-quest-event-config */
export const DailyQuestEventConfig: IDailyQuestEventConfig = {
  // ------ Общие настройки ивента ---------------- ||
  useSimpleMainBanner: true,
  eventNameLocale: 'Around the World',
  eventBrandSrc: '',
  eventLogoIconSrc: DOMAIN + EVENT_NAME + 'icon.webp',
  eventLogoSrc: DOMAIN + EVENT_NAME + 'icon.webp',
  checkMarkIconSrc: DOMAIN + EVENT_NAME + 'Checkmark.svg',
  homePageBackgroundColor: '#121719',
  //  ------ Настройки табов навигации ------------ ||
  navigationTabColorPalette: {
    background: '#121719',
    firstSphere: '#43c4b5',
    secondSphere: '#43c4b5',
    thirdSphere: '#43c4b5',
  },
  navigationTabActiveColorPalette: {
    background: '#43c4b5',
    firstSphere: '#43c4b5',
    secondSphere: '#43c4b5',
    thirdSphere: '#43c4b5',
  },
  // first tab
  navigationTabFirstImg: DOMAIN + EVENT_NAME + HOME_DIR_NAME + FILES_DIR_NAME + 'Left.webp',
  navigationTabResultFirstImg: DOMAIN + EVENT_NAME + HOME_DIR_NAME + FILES_DIR_NAME + 'Left.webp',
  navigationTabFirstLocale: 'LOCAL.REGULAR_EVENT.OPERATION',
  navigationTabFirstLocaleResults: 'LOCAL.NY_EVENT.FINAL.TOP_PLAYERS',
  // first tab complex
  complexFirstTab: {
    default: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_left_def.webp',
    active: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_left_active.webp',
    hover: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_left_active.webp',
    mobile: {
      default: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_left_def.webp',
      active: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_left_active.webp',
    },
  },
  // second tab
  navigationTabSecondImg: DOMAIN + EVENT_NAME + HOME_DIR_NAME + FILES_DIR_NAME + 'Right.webp',
  navigationTabResultSecondImg: DOMAIN + EVENT_NAME + HOME_DIR_NAME + FILES_DIR_NAME + 'Right.webp',
  navigationTabSecondLocale: 'LOCAL.REGULAR_EVENT.QUESTS',
  navigationTabSecondLocaleResults: 'LOCAL.NY_EVENT.CASES_SHOP',
  // second tab complex
  complexSecondTab: {
    default: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_right_def.webp',
    active: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_right_active.webp',
    hover: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_right_active.webp',
    mobile: {
      default: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_right_def.webp',
      active: DOMAIN + EVENT_NAME + FILES_DIR_NAME + 'tab_right_active.webp',
    },
  },
  //  ------ Настройки баннера -------------------- ||
  bannerImgSrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'main_backgr/main_back.webp',
  bannerMobileImgSrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'bg-for-main.webp',
  bannerVideoSrc: '',
  bannerSubImgSrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'main_backgr/girl.webp',
  bannerLeftImgSrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + FILES_DIR_NAME + 'logo2.webp',
  bannerRightImgSrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'main_backgr/Textmain.webp',
  // bannerTimerBgSrc: 'url(' + DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'Start_button/button_plate.svg' + ')',
  bannerTimerBgSrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'main_backgr/time_wrapper.webp',
  bannerTimerBgHoverSrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'main_backgr/Start_button.webp',
  // ------ Настройки нижнего баннера ------------- ||
  homePageBottomBannerSrc: 'url(' + DOMAIN + EVENT_NAME + 'cookie.webp' + ')',
  homePageBottomBannerMobSrc: 'url(' + DOMAIN + EVENT_NAME + 'cookie.webp' + ')',
  superPrizeBackgroundSrc: '',
  superPrizeMobBackgroundSrc: '',
  caseBackgroundSrc: DOMAIN + EVENT_NAME + 'operation_plates/plate{index}.webp',
  homePageBottomBannerImgSrc: '',
  // -----  Настройки карточки кейсов ивента ------ ||
  eventCaseProgressBarConfig: {
    backgroundColor: 'linear-gradient(#2f3c42, #2f3c42)',
    resultTextColor: '',
    borderWidth: '0px',
    borderColor: 'linear-gradient(to bottom, transparent, transparent)',
    barColor: '#F7C445',
    barBorderColor: '#F7C445',
    progressDropShadow: 'transparent',
    progressHeight: '12px',
  },
  //
  superPrizeProgressBarConfig: {
    backgroundColor: 'linear-gradient(#2f3c42, #2f3c42)',
    resultTextColor: '',
    borderWidth: '0px',
    borderColor: 'linear-gradient(to bottom, transparent, transparent)',
    barColor: '#F7C039',
    barBorderColor: '#F7C039',
    progressDropShadow: 'transparent',
    progressHeight: '12px',
  },
  eventCaseCheckMarkIconSrc: 'assets/img/ny-event/summer-event/success.svg',
  eventCaseMainPrizeSrc: DOMAIN + EVENT_NAME + `Img_Operation/SUPER_CASE_2x.webp`,
  // ------ Настройки валюты -----------------------||
  bronzeCurrencySrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'event_currency/Property_Bronze_coin_2x.webp',
  silverCurrencySrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'event_currency/Property_Silver_coin_2x.webp',
  goldCurrencySrc: DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'event_currency/Property_Gold_coin_2x.webp',
  // currencyMap: {
  /** bronze currency */
  //  'orange-key': DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'event_currency/Property_Bronze_coin_2x.webp',
  /** silver currency */
  //  'green-key': DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'event_currency/Property_Silver_coin_2x.webp',
  /** gold currency */
  //  'blue-key': DOMAIN + EVENT_NAME + HOME_DIR_NAME + 'event_currency/Property_Gold_coin_2x.webp',
  // },
  currencyMap: {
    'orange-key': DOMAIN + '/skins-baron-event/icons/Icon_bronze.webp',
    'green-key': DOMAIN + '/skins-baron-event/icons/icon_silver.webp',
    'blue-key': DOMAIN + '/skins-baron-event/icons/Icon_glod.webp',
  },
  // ------ Настройки ежедневных квестов ---------- ||
  dailyProgressFillColor: '#EDA13C',
  // ------ Настройки еженедельных квестов -------- ||
  weeklyProgressFillColor: '#F9D06C',
  weeklyFinalQuestProgressFillColor: '#fac106',
  weeklyQuestBgColor: '#3F68A7',
  weeklyQuestActiveBgColor: '#8BB9FF',
  weeklyQuestFinalBgColor: '#FAC106',
  //  ------ Настройки FAQ ------------------------ ||
  questGuideAllCurrencySrc: DOMAIN + EVENT_NAME + 'Coins.png',
  questGuideTextColorConfig: {
    firstColumn: '#F9741C',
    secondColumn: '#599AFF',
    thirdColumn: '#FAC106',
  },
  questGuideDailyDescription: [
    'LOCAL.NY_EVENT.EVENT_MODAL.DAILY_1',
    'LOCAL.NY_EVENT.EVENT_MODAL.DAILY_2',
    'LOCAL.NY_EVENT.EVENT_MODAL.DAILY_3',
  ],
  questGuideWeeklyDescription: [
    'LOCAL.NY_EVENT.EVENT_MODAL.WEEKLY_1',
    'LOCAL.NY_EVENT.EVENT_MODAL.WEEKLY_2',
    'LOCAL.NY_EVENT.EVENT_MODAL.WEEKLY_3',
    'LOCAL.NY_EVENT.EVENT_MODAL.WEEKLY_4',
  ],
  questGuideSpecialDescription: ['LOCAL.NY_EVENT.EVENT_MODAL.SPECIAL_1', 'LOCAL.NY_EVENT.EVENT_MODAL.SPECIAL_2'],
};
